class FiltersIndices extends HTMLElement {
  constructor() {
    super();
    this.activeFilters = new Map();
    this.productData = {};
    this.availableValues = {};
  }

  connectedCallback() {
    this.parseProductData();
    this.computeAvailableValues();
    this.updateAvailability();
    this.bindEvents();
    this.updateActiveIndicesCountUI();
    this.updateFilterUI();
    this.observeGridChanges();
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  parseProductData() {
    const script = document.getElementById("indice-collection-data");
    if (!script) return;
    try {
      this.productData = JSON.parse(script.textContent);
    } catch (e) {
      console.error("[FiltersIndices] Invalid JSON:", e);
    }
  }

  computeAvailableValues() {
    this.availableValues = {};

    const handles = Array.from(this.querySelectorAll("[data-indice-handle]")).map((col) => col.dataset.indiceHandle);

    for (const handle of handles) {
      const otherFilters = new Map([...this.activeFilters].filter(([h]) => h !== handle));

      const pool = Object.values(this.productData).filter((indices) => {
        if (!indices || Object.keys(indices).length === 0) return false;
        for (const [h, v] of otherFilters) {
          if (indices[h] !== v) return false;
        }
        return true;
      });

      this.availableValues[handle] = new Set();
      for (const indices of pool) {
        if (indices[handle] !== undefined) {
          this.availableValues[handle].add(indices[handle]);
        }
      }
    }
  }

  updateAvailability() {
    this.querySelectorAll("[data-indice-handle]").forEach((column) => {
      const handle = column.dataset.indiceHandle;
      const available = this.availableValues[handle] || new Set();

      column.querySelectorAll(".range-indice-item").forEach((item) => {
        const isAvailable = available.has(item.dataset.indice);
        item.classList.toggle("range-indice-item-disabled", !isAvailable);
      });
    });
  }

  bindEvents() {
    this.querySelectorAll(".range-indice-item").forEach((item) => {
      item.addEventListener("click", (e) => this.onItemClick(e));
    });
  }

  reset() {
    this.activeFilters.clear();
    this.computeAvailableValues();
    this.updateAvailability();
    this.updateFilterUI();
    this.updateActiveIndicesCountUI();
    this.applyFilters();
  }

  updateActiveIndicesCountUI() {
    // Affiche le nombre d'indices sélectionnés (1, 2, 3...) dans le reset du menu.
    const countEls = document.querySelectorAll("[data-indices-active-count]");
    countEls.forEach((el) => {
      el.textContent = this.activeFilters.size;
    });
  }

  observeGridChanges() {
    const grid = document.getElementById("ProductGridContainer");
    if (!grid) return;

    let debounceTimer;
    this.observer = new MutationObserver(() => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        this.parseProductData();
        this.computeAvailableValues();
        this.updateAvailability();
        this.applyFilters();
      }, 50);
    });
    this.observer.observe(grid, { childList: true, subtree: true });
  }

  onItemClick(event) {
    const item = event.currentTarget;
    const column = item.closest("[data-indice-handle]");
    if (!column) return;

    const handle = column.dataset.indiceHandle;
    const value = item.dataset.indice;

    if (this.activeFilters.get(handle) === value) {
      this.activeFilters.delete(handle);
    } else {
      this.activeFilters.set(handle, value);
    }

    this.computeAvailableValues();
    this.updateAvailability();
    this.updateFilterUI();
    this.updateActiveIndicesCountUI();
    this.applyFilters();
  }

  updateFilterUI() {
    this.querySelectorAll("[data-indice-handle]").forEach((column) => {
      const handle = column.dataset.indiceHandle;
      const activeValue = this.activeFilters.get(handle);

      column.querySelectorAll(".range-indice-item").forEach((item) => {
        item.classList.toggle("range-indice-item-active", item.dataset.indice === activeValue);
      });
    });
  }

  applyFilters() {
    const cards = document.querySelectorAll("[data-product-id]");
    const hasFilters = this.activeFilters.size > 0;

    // Compter les résultats depuis le JSON (productData)
    let visibleCount = 0;
    for (const indices of Object.values(this.productData)) {
      if (this.matchesAll(indices)) visibleCount += 1;
    }

    // Si une colonne a toutes ses valeurs disabled (aucun produit dans le pool), afficher 0
    const handles = this.querySelectorAll("[data-indice-handle]");
    for (const col of handles) {
      const handle = col.dataset.indiceHandle;
      if (!this.availableValues[handle] || this.availableValues[handle].size === 0) {
        visibleCount = 0;
        break;
      }
    }

    // Mise à jour de l’opacité des cartes
    cards.forEach((card) => {
      const id = card.dataset.productId;
      const indices = this.productData[id];

      if (!hasFilters) {
        card.classList.remove("hidden");
        return;
      }
      card.classList.toggle("hidden", !this.matchesAll(indices));
    });

    const countEl = document.getElementById("codex-visible-count");
    if (countEl) {
      countEl.textContent = visibleCount === 1 ? "1 résultat" : `${visibleCount} résultats`;
    }
  }

  matchesAll(indices) {
    if (!indices || Object.keys(indices).length === 0) return false;

    for (const [handle, value] of this.activeFilters) {
      if (indices[handle] !== value) return false;
    }
    return true;
  }
}

customElements.define("filters-indices", FiltersIndices);
